import { api } from "@/lib/api";

const KEY = "evr_ref";
const WINDOW_MS = 90 * 24 * 3600 * 1000;

export function captureRef() {
  const code = new URLSearchParams(window.location.search).get("ref");
  if (!code || !/^[a-z0-9]{3,40}$/i.test(code)) return;
  api.post("/affiliates/click", { code }).then(({ data }) => {
    if (data.valid) localStorage.setItem(KEY, JSON.stringify({ code: code.toLowerCase(), at: Date.now(), attributed: false }));
  }).catch(() => {});
}

export function getRef() {
  try {
    const r = JSON.parse(localStorage.getItem(KEY) || "null");
    return r && Date.now() - r.at < WINDOW_MS ? r : null;
  } catch { return null; }
}

export function attributeRef() {
  const r = getRef();
  if (!r || r.attributed) return;
  api.post("/affiliates/attribute", { code: r.code }).then(() => localStorage.setItem(KEY, JSON.stringify({ ...r, attributed: true }))).catch(() => {});
}
